/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetOrCreateChatResponse } from '../../models/get-or-create-chat-response';

export interface GetOrCreateChatWithCompany$Params {
  companyId: number;
}

export function getOrCreateChatWithCompany(http: HttpClient, rootUrl: string, params: GetOrCreateChatWithCompany$Params, context?: HttpContext): Observable<StrictHttpResponse<GetOrCreateChatResponse>> {
  const rb = new RequestBuilder(rootUrl, getOrCreateChatWithCompany.PATH, 'get');
  if (params) {
    rb.path('companyId', params.companyId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetOrCreateChatResponse>;
    })
  );
}

getOrCreateChatWithCompany.PATH = '/api/chat/get-or-create-with-company/{companyId}';
